import { Box, Grid, Typography } from "@mui/material";
import { Children, ReactElement } from "react";
import { optionsSubCategoryStyleProps } from "../theme/main";
import { OptionProps } from "./Option";

type OptionsSubCategoryProps = {
  title: string;
  children?: ReactElement<OptionProps> | ReactElement<OptionProps>[];
};

export function OptionsSubCategory({
  title,
  children,
}: OptionsSubCategoryProps) {
  const { titleStyle, titleChildrenSpace, gridStyle } =
    optionsSubCategoryStyleProps;

  return (
    <Box sx={{ width: "100%" }}>
      <Typography sx={titleStyle}>{title}</Typography>
      <Box sx={titleChildrenSpace} />
      <Grid container sx={gridStyle}>
        {Children.map(children, (child) => (
          <Grid>{child}</Grid>
        ))}
      </Grid>
    </Box>
  );
}
